import { render, staticRenderFns } from "./garden10.vue?vue&type=template&id=18685bea&scoped=true"
import script from "./garden10.vue?vue&type=script&lang=js"
export * from "./garden10.vue?vue&type=script&lang=js"
import style0 from "./garden10.vue?vue&type=style&index=0&id=18685bea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18685bea",
  null
  
)

export default component.exports